document.addEventListener('DOMContentLoaded', function() {
  // Store original product description and title
  let originalDescription = '';
  let originalTitle = '';
  
  // Find and store the original product description and title
  function storeOriginalContent() {
    const productDescriptionElement = document.querySelector('[data-product-description]');
    if (productDescriptionElement && !originalDescription) {
      originalDescription = productDescriptionElement.innerHTML;
    }
    const productTitleElement = document.querySelector('[data-product-title]');
    if (productTitleElement && !originalTitle) {
      originalTitle = productTitleElement.innerHTML;
    }
  }
  // Update variant gallery visibility based on data-id matching

  function updateVariantGalleryVisibility() {
    const productBannerWrap = document.querySelector('.product-banner__left');
    const variantGalleries = document.querySelectorAll('.variant-gallery');
    const defaultGallery = document.getElementById('default-product-gallery');

    if (!productBannerWrap || variantGalleries.length === 0) {
      console.warn('⚠️ productBannerWrap or variantGalleries not found');
      return;
    }
    const productDataId = (productBannerWrap.getAttribute('data-id') || '').trim();
    let hasMatchingVariant = false;
    let matchingGallery = null;

    // First, hide ALL galleries (including default)
    variantGalleries.forEach(gallery => {
      gallery.classList.add('hide');
      gallery.classList.remove('show');
      gallery.removeAttribute('data-variant-active');
    });

    if (defaultGallery) {
      defaultGallery.classList.add('hide');
      defaultGallery.classList.remove('show');
    }

    // Loop through variant galleries to find a match
    variantGalleries.forEach(gallery => {
      const variantId = (gallery.getAttribute('data-variant-id') || '').trim();
      // Match check
      if (productDataId && variantId && productDataId === variantId) {
        hasMatchingVariant = true;
        matchingGallery = gallery;
      }
    });

    // Show the appropriate gallery
    if (hasMatchingVariant && matchingGallery) {
      // Show matching variant gallery
      matchingGallery.classList.remove('hide');
      matchingGallery.classList.add('show');
      matchingGallery.setAttribute('data-variant-active', 'true');
      
    } else {
      // Show default gallery as fallback
      if (defaultGallery) {
        defaultGallery.classList.remove('hide');
        defaultGallery.classList.add('show');
        defaultGallery.setAttribute('data-variant-active', 'true');

      } else {
        console.warn('⚠️ No matching variant and no default gallery found');
      }
    }

  }
  // Update product description based on selected chiller option
  function updateProductDescription(selectedvariant) {
    const productDescriptionElement = document.querySelector('[data-product-description]');
    if (!productDescriptionElement) return;
    
    const chillerDescription = selectedvariant.querySelector('.chiller-option-card__description');
    
    if (chillerDescription && chillerDescription.textContent.trim()) {
      productDescriptionElement.innerHTML = chillerDescription.innerHTML;
    } else {
      if (originalDescription) {
        productDescriptionElement.innerHTML = originalDescription;
      }
    }

    // Initialize Cuttr for truncation
   const textDescclassic = document.querySelector('.product-banner__right .text-desc .metafield-multi_line_text_field');
    const textDesccls = document.querySelector('.product-banner__right .text-desc');

    if (textDesccls) {
      const fullText = textDesccls.innerHTML.trim();
      const maxLength = 300;

      if (fullText.length > maxLength) {
        const truncatedHTML = fullText.slice(0, maxLength);
        
        // Create button element
        const button = document.createElement("button");
        button.textContent = "See More";
        button.style.fontStyle = "italic";
        button.style.fontWeight = "500";
        button.style.color = "#ffa3a3";
        button.style.marginLeft = "5px";
        button.style.background = "none";
        button.style.border = "none";
        button.style.cursor = "pointer";
        button.style.padding = "0";

        // Set truncated content with inline button
        textDesccls.innerHTML = truncatedHTML.replace(/<\/?p>/g, '') + "... ";
        textDesccls.appendChild(button);
        textDesccls.classList.remove("remove_line_clamp");
        textDesccls.classList.add("cuttr--loaded");

        // Toggle functionality
        button.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (textDesccls.classList.contains("remove_line_clamp")) {
            // Collapse: show truncated text
            textDesccls.innerHTML = truncatedHTML.replace(/<\/?p>/g, '') + "... ";
            textDesccls.appendChild(button);
            button.textContent = "See More";
            textDesccls.classList.remove("remove_line_clamp");
          } else {
            // Expand: show full text
            textDesccls.innerHTML = fullText.replace(/<\/?p>/g, '') + " ";
            textDesccls.appendChild(button);
            button.textContent = "See Less";
            textDesccls.classList.add("remove_line_clamp");
          }
        });
      } else {
        // No truncation needed
        textDesccls.innerHTML = fullText;
        textDesccls.classList.remove("remove_line_clamp");
        textDesccls.classList.remove("cuttr--loaded");
      }
    } else if (textDescclassic) {
      const fullText = textDescclassic.innerHTML.trim();
      const maxLength = 300;

      if (fullText.length > maxLength) {
        const truncatedHTML = fullText.slice(0, maxLength);
        
        // Create button element
        const button = document.createElement("button");
        button.textContent = "See More";
        button.style.fontStyle = "italic";
        button.style.fontWeight = "500";
        button.style.color = "#ffa3a3";
        button.style.marginLeft = "5px";
        button.style.background = "none";
        button.style.border = "none";
        button.style.cursor = "pointer";
        button.style.padding = "0";

        // Set truncated content with inline button
        textDescclassic.innerHTML = truncatedHTML.replace(/<\/?p>/g, '') + "... ";
        textDescclassic.appendChild(button);
        textDescclassic.classList.remove("remove_line_clamp");
        textDescclassic.classList.add("cuttr--loaded");

        // Toggle functionality
        button.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (textDescclassic.classList.contains("remove_line_clamp")) {
            // Collapse: show truncated text
            textDescclassic.innerHTML = truncatedHTML.replace(/<\/?p>/g, '') + "... ";
            textDescclassic.appendChild(button);
            button.textContent = "See More";
            textDescclassic.classList.remove("remove_line_clamp");
          } else {
            // Expand: show full text
            textDescclassic.innerHTML = fullText.replace(/<\/?p>/g, '') + " ";
            textDescclassic.appendChild(button);
            button.textContent = "See Less";
            textDescclassic.classList.add("remove_line_clamp");
          }
        });
      } else {
        // No truncation needed
        textDescclassic.innerHTML = fullText.replace(/<\/?p>/g, '');
        textDescclassic.classList.remove("remove_line_clamp");
        textDescclassic.classList.remove("cuttr--loaded");
      }
    }

// for premium product section
    const textDescmeta = document.querySelector('.product-banner-premium__right .text-desc .metafield-multi_line_text_field');
const textDesc = document.querySelector('.product-banner-premium__right .text-desc');

if (textDesc) {
  const fullText = textDesc.innerHTML.trim();
  const maxLength = 300;

  if (fullText.length > maxLength) {
    const truncatedHTML = fullText.slice(0, maxLength);
    
    // Create button element
    const button = document.createElement("button");
    button.textContent = "See More";
    button.style.fontStyle = "italic";
    button.style.fontWeight = "500";
    button.style.color = "#ffa3a3";
    button.style.marginLeft = "5px";
    button.style.background = "none";
    button.style.border = "none";
    button.style.cursor = "pointer";
    button.style.padding = "0";

    // Set truncated content with inline button
    textDesc.innerHTML = truncatedHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + "... ";
    textDesc.appendChild(button);
    textDesc.classList.remove("remove_line_clamp");
    textDesc.classList.add("cuttr--loaded");

    // Toggle functionality
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (textDesc.classList.contains("remove_line_clamp")) {
        // Collapse: show truncated text
        textDesc.innerHTML = truncatedHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + "... ";
        textDesc.appendChild(button);
        button.textContent = "See More";
        textDesc.classList.remove("remove_line_clamp");
      } else {
        // Expand: show full text
        textDesc.innerHTML = fullText.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + " ";
        textDesc.appendChild(button);
        button.textContent = "See Less";
        textDesc.classList.add("remove_line_clamp");
      }
    });
  } else {
    // No truncation needed
    textDesc.innerHTML = fullText.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '');
    textDesc.classList.remove("remove_line_clamp");
    textDesc.classList.remove("cuttr--loaded");
  }
} else if (textDescmeta) {
  const fullText = textDescmeta.innerHTML.trim();
  const maxLength = 300;

  if (fullText.length > maxLength) {
    const truncatedHTML = fullText.slice(0, maxLength);
    
    // Create button element
    const button = document.createElement("button");
    button.textContent = "See More";
    button.style.fontStyle = "italic";
    button.style.fontWeight = "500";
    button.style.color = "#ffa3a3";
    button.style.marginLeft = "5px";
    button.style.background = "none";
    button.style.border = "none";
    button.style.cursor = "pointer";
    button.style.padding = "0";

    // Set truncated content with inline button
    textDescmeta.innerHTML = truncatedHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + "... ";
    textDescmeta.appendChild(button);
    textDescmeta.classList.remove("remove_line_clamp");
    textDescmeta.classList.add("cuttr--loaded");

    // Toggle functionality
    button.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (textDescmeta.classList.contains("remove_line_clamp")) {
        // Collapse: show truncated text
        textDescmeta.innerHTML = truncatedHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + "... ";
        textDescmeta.appendChild(button);
        button.textContent = "See More";
        textDescmeta.classList.remove("remove_line_clamp");
      } else {
        // Expand: show full text
        textDescmeta.innerHTML = fullText.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '') + " ";
        textDescmeta.appendChild(button);
        button.textContent = "See Less";
        textDescmeta.classList.add("remove_line_clamp");
      }
    });
  } else {
    // No truncation needed
    textDescmeta.innerHTML = fullText.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '');
    textDescmeta.classList.remove("remove_line_clamp");
    textDescmeta.classList.remove("cuttr--loaded");
  }
}
  }
  // Update product title based on selected chiller option
  function updateProductTitle(selectedCard) {

    const productTitleElement = document.querySelector('[data-product-title]');
    if (!productTitleElement) return;
    
    const chillerTitle = selectedCard.querySelector('.chiller-option-card__title');
    
    if (chillerTitle && chillerTitle.textContent.trim()) {
      
      productTitleElement.innerHTML = chillerTitle.innerHTML;
    } else {
      if (originalTitle) {
        productTitleElement.innerHTML = originalTitle;
      }
    }
  }
  // Get variant data
  function getVariantData(variantId) {
    if (typeof window.productVariants !== 'undefined') {
      return window.productVariants.find(v => v.id == variantId);
    }
    
    if (typeof window.product !== 'undefined' && window.product.variants) {
      return window.product.variants.find(v => v.id == variantId);
    }
    
    return null;
  }
  // Update product banner data-id and trigger all related updates
  function updateProductBannerDataId(selectedCard, variantId, isAvailable) {

    const productBannerWrap = document.querySelector('.product-banner__left');
    if (!productBannerWrap) return;
    if (variantId) {
      productBannerWrap?.setAttribute('data-id', variantId);
    } else {
      productBannerWrap?.removeAttribute('data-id');
    }
    updateVariantGalleryVisibility();
  }
  // Update visual states for chiller cards
  function updateChillerCardStates(selectedInput) {
    const chillerPicker = selectedInput.closest('.chiller-variant-picker');
    if (!chillerPicker) return;
    
    const allCards = chillerPicker.querySelectorAll('.chiller-option-card');
    const selectedCard = selectedInput.closest('.chiller-option-card');
    
    // Remove selected class from all cards
    allCards.forEach(card => {
      card.classList.remove('chiller-option-card--selected');
    });
    
    // Add selected class to the selected card
    if (selectedCard) {
      selectedCard.classList.add('chiller-option-card--selected');
    }
  }
  // Get all variant options
  function getAllVariantOptions() {
    const chillerPicker = document.querySelector('.chiller-variant-picker');
    if (!chillerPicker) return [];
    return chillerPicker.querySelectorAll('.chiller-option-card__input');
  }
  // Check if variant is available
  function isVariantAvailable(variantId) {
    const variantData = getVariantData(variantId);
    return variantData ? variantData.available : true;
  }
  function handleChillerToggle(clickedButton) {
      const allToggleButtons = document.querySelectorAll('.toggle-btn');
      allToggleButtons.forEach(btn => btn.classList.remove('active'));
      const chillerToggleValue = clickedButton.getAttribute('data-chiller-toggle');
      if(chillerToggleValue === 'no'){
          const firstInput = document.querySelectorAll('.chiller-option-card__input + label')[0];
          firstInput.click();

      } else if(chillerToggleValue === 'yes'){
        const secondInput = document.querySelectorAll('.chiller-option-card__input + label')[1];
        secondInput.click();
      }
  }

  // Simple standalone function version
function setupVariantChangeHandler() {
  const variantPickers = document.querySelectorAll('variant-picker');
  
  variantPickers.forEach(picker => {
    // Listen for variant changes
    picker.addEventListener('variant:changed', (event) => {
      handleVariantChange(event.detail.variant);
    });
    
    // Also listen for direct option changes
    const optionInputs = picker.querySelectorAll('input[data-option-position]');
    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Get the current variant from the picker's data
        const variantScript = picker.querySelector('script[data-variant]');
        if (variantScript) {
          const variant = JSON.parse(variantScript.textContent);
          handleVariantChange(variant);
        }
      });
    });
  });
  
  // Initialize with current variant
  const variantScript = document.querySelector('script[data-variant]');
  if (variantScript) {
    const initialVariant = JSON.parse(variantScript.textContent);
    handleVariantChange(initialVariant);
  }
}

function handleVariantChange(variant) {
  console.log('Variant changed to:', variant);
  // Update chiller/attachment cards selection
  updateCardSelection(variant);
  // Update toggle buttons
  updateToggleState(variant);
}

function updateCardSelection(variant) {
  const cards = document.querySelectorAll('.chiller-option-card');
  
  cards.forEach(card => {
    const cardVariantId = card.getAttribute('data-id');
    const input = card.querySelector('input');
    
    if (cardVariantId === variant.id.toString()) {
      card.classList.add('chiller-option-card--selected');
      if (input) input.checked = true;
    } else {
      card.classList.remove('chiller-option-card--selected');
      if (input) input.checked = false;
    }
  });
}

function updateToggleState(variant) {
  const toggleButtons = document.querySelectorAll('.toggle-btn');
  const hasAddOn = document.querySelector('.chiller-option-card--selected:not(.chiller-option-card--hidden)');
  
  toggleButtons.forEach(button => {
    const toggleType = button.getAttribute('data-chiller-toggle');
    
    if (toggleType === 'yes' && hasAddOn) {
      button.classList.add('active');
    } else if (toggleType === 'no' && !hasAddOn) {
      button.classList.add('active');
    } else {
      button.classList.remove('active');
    }
  });
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', setupVariantChangeHandler);

  // Event listener for toggle buttons
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('toggle-btn')) {
    handleChillerToggle(event.target);
    
    // Wait a moment for the click to register and then get the selected card
    setTimeout(() => {
      const selectedInput = document.querySelector('.chiller-option-card__input:checked');
      if (selectedInput) {
        const selectedCard = selectedInput.closest('.chiller-option-card');
        const selectedvariant = document.querySelector('.variant-picker');
        const variantId = selectedvariant?.getAttribute('selected-variant');
        const isAvailable = isVariantAvailable(variantId);
        
        // Update visual states and product info
        updateChillerCardStates(selectedInput);
        updateProductDescription(selectedvariant);
        updateProductTitle(selectedvariant);
        updateProductBannerDataId(selectedCard, variantId, isAvailable);
        updateVariantGalleryVisibility();
      }
    }, 50);
  }
});
  // Store original content on page load
  storeOriginalContent();
  // Handle variant selection only
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('chiller-option-card__input')) {
      const input = event.target;
      const selectedCard = input.closest('.chiller-option-card');
      const selectedvariant = document.querySelector('.variant-picker');
      const variantId = selectedvariant.getAttribute('selected-variant');
      const isAvailable = isVariantAvailable(variantId);
      // Update visual states and product info
      updateChillerCardStates(input);
      updateProductDescription(selectedvariant);
      updateProductTitle(selectedvariant);
      updateProductBannerDataId(selectedCard, variantId, isAvailable);
      updateVariantGalleryVisibility();
    }
    if (event.target.classList.contains('chiller_combi_option_change')) {
      
      const selectedCard = document.querySelector('.variant-picker');
      const selectedvariant = document.querySelector('.variant-picker');
      const variantId = selectedvariant.getAttribute('selected-variant');

      const isAvailable = isVariantAvailable(variantId);
      // Update visual states and product info
      updateProductDescription(selectedvariant);
      updateProductTitle(selectedCard);
      updateProductBannerDataId(selectedCard, variantId, isAvailable);
      updateVariantGalleryVisibility();
      
    }
  });
  // Handle initial state
  setTimeout(function() {
    const initialSelectedChiller = document.querySelector('.chiller-option-card__input:checked');
    
    if (initialSelectedChiller) {
      // const initialCard = initialSelectedChiller.closest('.chiller-option-card');
      const selectedvariant = document.querySelector('.variant-picker');
      const variantId = selectedvariant.getAttribute('selected-variant');
      const isAvailable = isVariantAvailable(variantId);
      updateProductDescription(selectedvariant);
      updateProductTitle(selectedvariant);
      updateProductBannerDataId(selectedvariant, variantId, isAvailable);
      updateChillerCardStates(initialSelectedChiller);
    } else {
      // If no chiller option is selected, select the first one by default
      const allVariants = getAllVariantOptions();
      const firstVariant = allVariants[0];
      if (firstVariant) {
        firstVariant.checked = true;
        updateChillerCardStates(firstVariant);
        const selectedCard = firstVariant.closest('.chiller-option-card');
        if (selectedCard) {
          const selectedvariant = input.closest('.variant-picker');
          const variantId = selectedvariant.getAttribute('selected-variant');
          // const variantId = selectedCard.getAttribute('data-id');
          const isAvailable = isVariantAvailable(variantId);
          updateProductDescription(selectedvariant);
          updateProductTitle(selectedCard);
          updateProductBannerDataId(selectedCard, variantId, isAvailable);
        }
      }
    }
    // Initialize variant gallery visibility
    updateVariantGalleryVisibility();
  }, 100);
});

(function() {
  const sizeInputs = document.querySelectorAll('input[data-option-position]');
  
  sizeInputs.forEach(input => {
    input.addEventListener('change', function() {
      // Check if this is a size option change
      const optionName = this.closest('.chiller-variant-picker')?.dataset.optionName;
      if (optionName && optionName.toLowerCase() === 'size') {
        // Trigger update of attachment cards
        updateAttachmentCards();
      }
    });
  });
  
  function updateAttachmentCards() {
    // Force a page refresh to reload variant data with new size selection
    // Alternatively, you could use AJAX to update the cards dynamically
    location.reload();
  }
})();